export enum Severity {
  error = 'error',
  info = 'info',
  success = 'success',
  warning = 'warning',
}

export enum EventType {
  delete = 'delete',
  create = 'create',
  update = 'update',
  upload = 'upload',
  load = 'load',
  login = 'login',
  restPassword = 'restPassword',
  registerUser = 'registerUser',
  confirmAccount = 'confirmAccount',
  changePassword = 'changePassword',
}

export type Message = {
  severity: Severity
  message: string
  eventType: EventType
}

export type Success = {
  [key: string]: any
}
